import script from "./BigNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigNumber.vue?vue&type=script&setup=true&lang=ts"

import "./BigNumber.vue?vue&type=style&index=0&id=bb9bf25e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb9bf25e"]])

export default __exports__